import v2 from './v2';
import v2Callback from './v2-callback';
import v3 from './v3';
import eventStream from './event-stream';
import { cloneDeep } from 'lodash'

export const ANALYTICS_SCHEMA_VERSION_V2 = 'ANALYTICS_SCHEMA_VERSION_V2';
export const ANALYTICS_SCHEMA_VERSION_V2_CALLBACK = 'ANALYTICS_SCHEMA_VERSION_V2_CALLBACK';
export const ANALYTICS_SCHEMA_VERSION_V3 = 'ANALYTICS_SCHEMA_VERSION_V3';
export const ANALYTICS_SCHEMA_VERSION_EVENT_STREAM = 'ANALYTICS_SCHEMA_VERSION_EVENT_STREAM';
export const AVAILABLE_ANALYTICS_SCHEMAS = [
  ANALYTICS_SCHEMA_VERSION_V2,
  ANALYTICS_SCHEMA_VERSION_V2_CALLBACK,
  ANALYTICS_SCHEMA_VERSION_V3,
  ANALYTICS_SCHEMA_VERSION_EVENT_STREAM,
];

const analyticsParser = (schemaVersion, originalData) => {
  const data = cloneDeep(originalData)
  const implementedSchemaVersions = [
    ANALYTICS_SCHEMA_VERSION_V2,
    ANALYTICS_SCHEMA_VERSION_V2_CALLBACK,
    ANALYTICS_SCHEMA_VERSION_EVENT_STREAM,
    ANALYTICS_SCHEMA_VERSION_V3,
  ];

  if (!implementedSchemaVersions.includes(schemaVersion)) {
    const error = `The given schemaVersion of '${schemaVersion}' is not implemented.
      Valid versions are ${implementedSchemaVersions.join(', ')}`;
    throw new Error(error);
  }

  let parsedData;
  switch (schemaVersion) {
    case ANALYTICS_SCHEMA_VERSION_V2:
      parsedData = v2(data);
      break;
    case ANALYTICS_SCHEMA_VERSION_V2_CALLBACK:
      parsedData = v2Callback(data);
      break;
    case ANALYTICS_SCHEMA_VERSION_V3:
      parsedData = v3(data);
      break;
    case ANALYTICS_SCHEMA_VERSION_EVENT_STREAM:
      parsedData = eventStream(data);
      break;
    default:
      // We shouldn't be able to get here. We already have an implemented schema check prior.
      break;
  }
  return parsedData;
};

export default analyticsParser;
